import { GraphQLResolveInfo } from 'graphql';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type EntireFieldWrapper<T> = T extends Array<infer U> ? Array<NonNullable<U>> : T;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export enum AdPlacementId {
  LowerThird = 'LOWER_THIRD',
  RightThird = 'RIGHT_THIRD'
}

/**  Core Types */
export type Advertisement = {
  __typename?: 'Advertisement';
  placementId: EntireFieldWrapper<AdPlacementId>;
  url: EntireFieldWrapper<Scalars['String']['output']>;
};

/**  Authentication */
export type AuthResponse = {
  __typename?: 'AuthResponse';
  token: EntireFieldWrapper<Scalars['String']['output']>;
  user: EntireFieldWrapper<User>;
};

export type Customer = {
  __typename?: 'Customer';
  customerId: EntireFieldWrapper<Scalars['String']['output']>;
  detachedDevices: EntireFieldWrapper<Maybe<Array<Maybe<Device>>>>;
  locations: EntireFieldWrapper<Maybe<Array<Maybe<Location>>>>;
  name: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
};

export type Device = {
  __typename?: 'Device';
  commandOutputs: EntireFieldWrapper<Maybe<Array<Maybe<DeviceCommandOutput>>>>;
  deviceId: EntireFieldWrapper<Scalars['String']['output']>;
  deviceProperties: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  lastUpd: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  name: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  screenshotTimestamp: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  screenshotUrl: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  slides: EntireFieldWrapper<Maybe<Array<Maybe<Slide>>>>;
  slideshowVersions: EntireFieldWrapper<Maybe<Array<Maybe<SlideshowVersion>>>>;
  status: EntireFieldWrapper<Maybe<DeviceStatusType>>;
  statusReport: EntireFieldWrapper<Maybe<DeviceStatusReport>>;
};

export type DeviceCommandOutput = {
  __typename?: 'DeviceCommandOutput';
  command: EntireFieldWrapper<Scalars['String']['output']>;
  deviceId: EntireFieldWrapper<Scalars['String']['output']>;
  output: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  receivedAt: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  timestamp: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
};

export type DeviceLiveData = {
  __typename?: 'DeviceLiveData';
  activeDevices: EntireFieldWrapper<Maybe<Scalars['Int']['output']>>;
  aspectRatio: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  commandOutputs: EntireFieldWrapper<Maybe<Array<Maybe<DeviceCommandOutput>>>>;
  deviceId: EntireFieldWrapper<Scalars['String']['output']>;
  deviceName: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  lastTimeActiveDevices: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  lastTimeConnected: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  locationId: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  locationName: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  statusReport: EntireFieldWrapper<Maybe<DeviceStatusReport>>;
};

export type DeviceStatusReport = {
  __typename?: 'DeviceStatusReport';
  avgLoad: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  connectedSsid: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  cpuLoad: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  deviceId: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  diskTotalGB: EntireFieldWrapper<Maybe<Scalars['Float']['output']>>;
  diskUsedGB: EntireFieldWrapper<Maybe<Scalars['Float']['output']>>;
  hdmi1_rotation: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  hdmi2_rotation: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  metrics: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  temperature: EntireFieldWrapper<Maybe<Scalars['Float']['output']>>;
  time: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  totalMemMB: EntireFieldWrapper<Maybe<Scalars['Int']['output']>>;
  uptimeMin: EntireFieldWrapper<Maybe<Scalars['Int']['output']>>;
  usedMemMB: EntireFieldWrapper<Maybe<Scalars['Int']['output']>>;
};

export enum DeviceStatusType {
  Active = 'ACTIVE',
  Detached = 'DETACHED',
  Inactive = 'INACTIVE',
  New = 'NEW'
}

/**  Sports Integration Types */
export type Event = {
  __typename?: 'Event';
  away: EntireFieldWrapper<Maybe<Team>>;
  awayScore: EntireFieldWrapper<Maybe<Scalars['Int']['output']>>;
  clock: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  closed: EntireFieldWrapper<Maybe<Scalars['Boolean']['output']>>;
  hasOdds: EntireFieldWrapper<Maybe<Scalars['Boolean']['output']>>;
  home: EntireFieldWrapper<Maybe<Team>>;
  homeScore: EntireFieldWrapper<Maybe<Scalars['Int']['output']>>;
  id: EntireFieldWrapper<Scalars['Int']['output']>;
  leagueId: EntireFieldWrapper<Maybe<Scalars['Int']['output']>>;
  live: EntireFieldWrapper<Maybe<Scalars['Boolean']['output']>>;
  name: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  sportId: EntireFieldWrapper<Maybe<Scalars['Int']['output']>>;
  startTime: EntireFieldWrapper<Scalars['String']['output']>;
  status: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
};

export type League = {
  __typename?: 'League';
  country: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  id: EntireFieldWrapper<Scalars['Int']['output']>;
  name: EntireFieldWrapper<Scalars['String']['output']>;
  sportId: EntireFieldWrapper<Scalars['Int']['output']>;
};

export type Location = {
  __typename?: 'Location';
  customerId: EntireFieldWrapper<Scalars['String']['output']>;
  devices: EntireFieldWrapper<Maybe<Array<Maybe<Device>>>>;
  locationId: EntireFieldWrapper<Scalars['String']['output']>;
  metrics: EntireFieldWrapper<Maybe<MetricsLocationData>>;
  name: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  slideshows: EntireFieldWrapper<Maybe<Array<Maybe<Slideshow>>>>;
};


export type LocationMetricsArgs = {
  endTime: InputMaybe<Scalars['String']['input']>;
  startTime: InputMaybe<Scalars['String']['input']>;
  unit: InputMaybe<TimeUnit>;
};

/**  Input Types for Mutations */
export type LoginInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type MediaItem = {
  __typename?: 'MediaItem';
  createdByUser: EntireFieldWrapper<Maybe<User>>;
  customerId: EntireFieldWrapper<Scalars['String']['output']>;
  height: EntireFieldWrapper<Maybe<Scalars['Int']['output']>>;
  lastUpd: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  locationId: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  mediaItemId: EntireFieldWrapper<Scalars['ID']['output']>;
  previewURL: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  tags: EntireFieldWrapper<Maybe<Array<Maybe<Scalars['String']['output']>>>>;
  type: EntireFieldWrapper<MediaType>;
  url: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  width: EntireFieldWrapper<Maybe<Scalars['Int']['output']>>;
};

/**  Enums */
export enum MediaType {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type MetricsDeviceStats = {
  __typename?: 'MetricsDeviceStats';
  activeDevices: EntireFieldWrapper<Maybe<Scalars['Int']['output']>>;
  deviceId: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  fromRoundedTimestamp: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  locationId: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  timestamp: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  toRoundedTimestamp: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
};

export type MetricsLocationData = {
  __typename?: 'MetricsLocationData';
  liveData: EntireFieldWrapper<Maybe<MetricsLocationStats>>;
  locationData: EntireFieldWrapper<Maybe<Array<Maybe<MetricsLocationStats>>>>;
  locationId: EntireFieldWrapper<Scalars['String']['output']>;
};

export type MetricsLocationDeviceData = {
  __typename?: 'MetricsLocationDeviceData';
  deviceData: EntireFieldWrapper<Maybe<Array<Maybe<MetricsDeviceStats>>>>;
  locationId: EntireFieldWrapper<Scalars['String']['output']>;
};

export type MetricsLocationStats = {
  __typename?: 'MetricsLocationStats';
  activeDevices: EntireFieldWrapper<Maybe<Scalars['Int']['output']>>;
  fromRoundedTimestamp: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  locationId: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  timestamp: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  toRoundedTimestamp: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
};

/**  Mutation Root */
export type Mutation = {
  __typename?: 'Mutation';
  /**  Customer/Location/Device */
  createCustomer: EntireFieldWrapper<Maybe<Customer>>;
  createDevice: EntireFieldWrapper<Maybe<Device>>;
  createLocation: EntireFieldWrapper<Maybe<Location>>;
  createMediaItem: EntireFieldWrapper<Maybe<MediaItem>>;
  /**  Slide/Slideshow/Media */
  createSlide: EntireFieldWrapper<Maybe<Slide>>;
  createSlideshow: EntireFieldWrapper<Maybe<Slideshow>>;
  createUser: EntireFieldWrapper<Maybe<User>>;
  deleteDevice: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  deleteMediaItem: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  deleteScheduledSlideshow: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  deleteScheduledSlideshowById: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  deleteSlide: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  deleteSlideshow: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  deleteUser: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  detachDevice: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  /**  User/Authentication */
  loginUser: EntireFieldWrapper<Maybe<AuthResponse>>;
  /**  Scheduling */
  scheduleSlideshow: EntireFieldWrapper<Maybe<ScheduledSlideshow>>;
  setDeviceCommands: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  /**  Sports Integration */
  setUpcomingEvents: EntireFieldWrapper<Maybe<Array<Maybe<Event>>>>;
  updateDevice: EntireFieldWrapper<Maybe<Device>>;
  updateDeviceProperties: EntireFieldWrapper<Maybe<Device>>;
  updateMediaItem: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  updateScheduledSlideshow: EntireFieldWrapper<Maybe<ScheduledSlideshow>>;
  updateSlide: EntireFieldWrapper<Maybe<Slide>>;
  updateSlideshow: EntireFieldWrapper<Maybe<Slideshow>>;
  updateUser: EntireFieldWrapper<Maybe<User>>;
};


/**  Mutation Root */
export type MutationCreateCustomerArgs = {
  input: NewCustomerInput;
};


/**  Mutation Root */
export type MutationCreateDeviceArgs = {
  input: NewDeviceInput;
};


/**  Mutation Root */
export type MutationCreateLocationArgs = {
  input: NewLocationInput;
};


/**  Mutation Root */
export type MutationCreateMediaItemArgs = {
  input: NewMediaItemInput;
};


/**  Mutation Root */
export type MutationCreateSlideArgs = {
  input: NewSlideInput;
};


/**  Mutation Root */
export type MutationCreateSlideshowArgs = {
  input: NewSlideshowInput;
};


/**  Mutation Root */
export type MutationCreateUserArgs = {
  input: NewUserInput;
};


/**  Mutation Root */
export type MutationDeleteDeviceArgs = {
  deviceId: Scalars['String']['input'];
};


/**  Mutation Root */
export type MutationDeleteMediaItemArgs = {
  force: InputMaybe<Scalars['Boolean']['input']>;
  mediaItemId: Scalars['String']['input'];
};


/**  Mutation Root */
export type MutationDeleteScheduledSlideshowArgs = {
  slideshowId: Scalars['String']['input'];
};


/**  Mutation Root */
export type MutationDeleteScheduledSlideshowByIdArgs = {
  id: Scalars['String']['input'];
};


/**  Mutation Root */
export type MutationDeleteSlideArgs = {
  slideId: Scalars['String']['input'];
};


/**  Mutation Root */
export type MutationDeleteSlideshowArgs = {
  slideshowId: Scalars['String']['input'];
};


/**  Mutation Root */
export type MutationDeleteUserArgs = {
  username: Scalars['String']['input'];
};


/**  Mutation Root */
export type MutationDetachDeviceArgs = {
  deviceId: Scalars['String']['input'];
};


/**  Mutation Root */
export type MutationLoginUserArgs = {
  input: LoginInput;
};


/**  Mutation Root */
export type MutationScheduleSlideshowArgs = {
  input: NewScheduledSlideshowInput;
};


/**  Mutation Root */
export type MutationSetDeviceCommandsArgs = {
  commands: Array<InputMaybe<Scalars['String']['input']>>;
  deviceId: Scalars['String']['input'];
};


/**  Mutation Root */
export type MutationSetUpcomingEventsArgs = {
  input: NewUpcomingEventsInput;
};


/**  Mutation Root */
export type MutationUpdateDeviceArgs = {
  input: UpdateDeviceInput;
};


/**  Mutation Root */
export type MutationUpdateDevicePropertiesArgs = {
  input: UpdateDevicePropertiesInput;
};


/**  Mutation Root */
export type MutationUpdateMediaItemArgs = {
  input: UpdateMediaItemInput;
};


/**  Mutation Root */
export type MutationUpdateScheduledSlideshowArgs = {
  input: UpdateScheduledSlideshowInput;
};


/**  Mutation Root */
export type MutationUpdateSlideArgs = {
  input: SlideInput;
};


/**  Mutation Root */
export type MutationUpdateSlideshowArgs = {
  input: SlideshowInput;
};


/**  Mutation Root */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type NewCustomerInput = {
  name: Scalars['String']['input'];
};

export type NewDeviceInput = {
  customerId: Scalars['String']['input'];
  locationId: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type NewLocationInput = {
  customerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type NewMediaItemInput = {
  customerId: Scalars['String']['input'];
  height: InputMaybe<Scalars['Int']['input']>;
  locationId: InputMaybe<Scalars['String']['input']>;
  previewURL: InputMaybe<Scalars['String']['input']>;
  tags: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: MediaType;
  url: Scalars['String']['input'];
  width: InputMaybe<Scalars['Int']['input']>;
};

export type NewScheduledSlideshowInput = {
  dateTime: Scalars['String']['input'];
  deviceIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  slideshowId: Scalars['String']['input'];
};

export type NewSlideInput = {
  customerId: Scalars['String']['input'];
  data: InputMaybe<Scalars['String']['input']>;
  layout: InputMaybe<Scalars['String']['input']>;
  locationId: InputMaybe<Scalars['String']['input']>;
  tags: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: InputMaybe<SlideType>;
};

export type NewSlideshowInput = {
  aspectRatio: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  level: SlideshowLevel;
  locationIds: Array<InputMaybe<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  slideIds: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type NewUpcomingEventsInput = {
  customerId: Scalars['String']['input'];
  eventIds: Array<InputMaybe<Scalars['Int']['input']>>;
  locationId: InputMaybe<Scalars['String']['input']>;
};

export type NewUserInput = {
  customerId: InputMaybe<Scalars['ID']['input']>;
  locationIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  password: Scalars['String']['input'];
  role: UserRole;
  userName: Scalars['String']['input'];
};

/**  Query Root */
export type Query = {
  __typename?: 'Query';
  /**  Customer/Location/Device Queries */
  getCustomers: EntireFieldWrapper<Maybe<Array<Maybe<Customer>>>>;
  getDevice: EntireFieldWrapper<Maybe<Device>>;
  getDeviceSlides: EntireFieldWrapper<Maybe<Array<Maybe<Slide>>>>;
  getDevicesLive: EntireFieldWrapper<Maybe<Array<Maybe<DeviceLiveData>>>>;
  /**  Sports Integration Queries */
  getEvents: EntireFieldWrapper<Maybe<Array<Maybe<Event>>>>;
  getEventsByIds: EntireFieldWrapper<Maybe<Array<Maybe<Event>>>>;
  getLeagues: EntireFieldWrapper<Maybe<Array<Maybe<League>>>>;
  getLocation: EntireFieldWrapper<Maybe<Location>>;
  getLocationDeviceMetrics: EntireFieldWrapper<Maybe<MetricsLocationDeviceData>>;
  getLocationMetrics: EntireFieldWrapper<Maybe<MetricsLocationData>>;
  /**  Media Queries */
  getMediaItem: EntireFieldWrapper<Maybe<MediaItem>>;
  getMediaItems: EntireFieldWrapper<Maybe<Array<Maybe<MediaItem>>>>;
  getScheduledSlideshows: EntireFieldWrapper<Maybe<Array<Maybe<ScheduledSlideshow>>>>;
  /**  Slide/Slideshow Queries */
  getSlide: EntireFieldWrapper<Maybe<Slide>>;
  getSlides: EntireFieldWrapper<Maybe<Array<Maybe<Slide>>>>;
  getSlideshow: EntireFieldWrapper<Maybe<Slideshow>>;
  getSlideshows: EntireFieldWrapper<Maybe<Array<Maybe<Slideshow>>>>;
  /**  User Queries */
  getUsers: EntireFieldWrapper<Maybe<Array<Maybe<User>>>>;
};


/**  Query Root */
export type QueryGetDeviceArgs = {
  deviceId: Scalars['String']['input'];
};


/**  Query Root */
export type QueryGetDeviceSlidesArgs = {
  deviceId: Scalars['String']['input'];
};


/**  Query Root */
export type QueryGetEventsArgs = {
  endDate: InputMaybe<Scalars['String']['input']>;
  startDate: InputMaybe<Scalars['String']['input']>;
};


/**  Query Root */
export type QueryGetEventsByIdsArgs = {
  list: Array<InputMaybe<Scalars['Int']['input']>>;
};


/**  Query Root */
export type QueryGetLocationArgs = {
  locationId: Scalars['String']['input'];
};


/**  Query Root */
export type QueryGetLocationDeviceMetricsArgs = {
  endTime: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  startTime: InputMaybe<Scalars['String']['input']>;
  unit: InputMaybe<TimeUnit>;
};


/**  Query Root */
export type QueryGetLocationMetricsArgs = {
  endTime: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  unit: InputMaybe<TimeUnit>;
};


/**  Query Root */
export type QueryGetMediaItemArgs = {
  mediaItemId: Scalars['ID']['input'];
};


/**  Query Root */
export type QueryGetMediaItemsArgs = {
  customerId: Scalars['String']['input'];
  locationId: InputMaybe<Scalars['String']['input']>;
  types: InputMaybe<Array<InputMaybe<MediaType>>>;
};


/**  Query Root */
export type QueryGetScheduledSlideshowsArgs = {
  slideshowId: Scalars['String']['input'];
};


/**  Query Root */
export type QueryGetSlideArgs = {
  slideId: Scalars['String']['input'];
};


/**  Query Root */
export type QueryGetSlidesArgs = {
  customerId: Scalars['String']['input'];
  locationId: InputMaybe<Scalars['String']['input']>;
};


/**  Query Root */
export type QueryGetSlideshowArgs = {
  slideshowId: Scalars['String']['input'];
};


/**  Query Root */
export type QueryGetSlideshowsArgs = {
  customerId: Scalars['String']['input'];
  level: SlideshowLevel;
  locationId: InputMaybe<Scalars['String']['input']>;
};


/**  Query Root */
export type QueryGetUsersArgs = {
  customerId: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledSlideshow = {
  __typename?: 'ScheduledSlideshow';
  dateTime: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  deviceIds: EntireFieldWrapper<Maybe<Array<Maybe<Scalars['String']['output']>>>>;
  id: EntireFieldWrapper<Scalars['String']['output']>;
  lastUpd: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  locationIds: EntireFieldWrapper<Maybe<Array<Maybe<Scalars['String']['output']>>>>;
  name: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  processed: EntireFieldWrapper<Maybe<Scalars['Boolean']['output']>>;
  slideshowId: EntireFieldWrapper<Scalars['String']['output']>;
  slideshowType: EntireFieldWrapper<SlideshowLevel>;
};

export type Slide = {
  __typename?: 'Slide';
  ads: EntireFieldWrapper<Maybe<Array<Maybe<Advertisement>>>>;
  createdByUser: EntireFieldWrapper<Maybe<User>>;
  customerId: EntireFieldWrapper<Scalars['String']['output']>;
  data: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  elements: EntireFieldWrapper<Maybe<Array<Maybe<MediaItem>>>>;
  lastUpd: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  layout: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  locationId: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  previewURL: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  slideId: EntireFieldWrapper<Scalars['ID']['output']>;
  tags: EntireFieldWrapper<Maybe<Array<Maybe<Scalars['String']['output']>>>>;
  type: EntireFieldWrapper<Maybe<SlideType>>;
};

export type SlideInput = {
  data: InputMaybe<Scalars['String']['input']>;
  elements: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  layout: InputMaybe<Scalars['String']['input']>;
  slideId: Scalars['ID']['input'];
  tags: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: InputMaybe<SlideType>;
};

export enum SlideType {
  Default = 'DEFAULT',
  Matches = 'MATCHES'
}

export type Slideshow = {
  __typename?: 'Slideshow';
  aspectRatio: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  customerId: EntireFieldWrapper<Scalars['String']['output']>;
  lastUpd: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  level: EntireFieldWrapper<Maybe<SlideshowLevel>>;
  locationIds: EntireFieldWrapper<Array<Maybe<Scalars['String']['output']>>>;
  name: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  schedules: EntireFieldWrapper<Maybe<Array<Maybe<ScheduledSlideshow>>>>;
  slideIds: EntireFieldWrapper<Maybe<Array<Maybe<Scalars['ID']['output']>>>>;
  slides: EntireFieldWrapper<Maybe<Array<Maybe<Slide>>>>;
  slideshowId: EntireFieldWrapper<Scalars['String']['output']>;
  userName: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
};

export type SlideshowInput = {
  aspectRatio: InputMaybe<Scalars['String']['input']>;
  level: InputMaybe<SlideshowLevel>;
  locationIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  slideIds: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  slideshowId: Scalars['String']['input'];
};

export enum SlideshowLevel {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Location = 'LOCATION'
}

export type SlideshowVersion = {
  __typename?: 'SlideshowVersion';
  level: EntireFieldWrapper<Maybe<SlideshowLevel>>;
  slideshowId: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
};

export type SlideshowVersionInput = {
  level: InputMaybe<SlideshowLevel>;
  slideshowId: InputMaybe<Scalars['String']['input']>;
};

export type Team = {
  __typename?: 'Team';
  country: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  displayName: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  gender: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  id: EntireFieldWrapper<Scalars['ID']['output']>;
  logo: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  name: EntireFieldWrapper<Scalars['String']['output']>;
  shortName: EntireFieldWrapper<Maybe<Scalars['String']['output']>>;
  sportId: EntireFieldWrapper<Maybe<Scalars['Int']['output']>>;
};

export enum TimeUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES'
}

export enum TransitionType {
  Fade = 'FADE',
  SlideLeft = 'SLIDE_LEFT',
  SlideRight = 'SLIDE_RIGHT'
}

export type UpdateDeviceInput = {
  deviceId: Scalars['String']['input'];
  locationId: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  slideshowVersions: InputMaybe<Array<InputMaybe<SlideshowVersionInput>>>;
  status: InputMaybe<DeviceStatusType>;
};

export type UpdateDevicePropertiesInput = {
  deviceId: Scalars['String']['input'];
  properties: Scalars['String']['input'];
};

export type UpdateMediaItemInput = {
  mediaItemId: Scalars['ID']['input'];
  tags: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateScheduledSlideshowInput = {
  dateTime: InputMaybe<Scalars['String']['input']>;
  deviceIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: InputMaybe<Scalars['String']['input']>;
  locationIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  processed: InputMaybe<Scalars['Boolean']['input']>;
  slideshowId: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  customerId: InputMaybe<Scalars['ID']['input']>;
  locationIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  password: InputMaybe<Scalars['String']['input']>;
  role: InputMaybe<UserRole>;
  userName: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  customer: EntireFieldWrapper<Maybe<Customer>>;
  customerId: EntireFieldWrapper<Maybe<Scalars['ID']['output']>>;
  locations: EntireFieldWrapper<Maybe<Array<Maybe<Location>>>>;
  role: EntireFieldWrapper<Maybe<UserRole>>;
  userName: EntireFieldWrapper<Scalars['String']['output']>;
};

export enum UserRole {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Location = 'LOCATION',
  LocationAdmin = 'LOCATION_ADMIN'
}



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AdPlacementId: AdPlacementId;
  Advertisement: ResolverTypeWrapper<Advertisement>;
  AuthResponse: ResolverTypeWrapper<AuthResponse>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Customer: ResolverTypeWrapper<Customer>;
  Device: ResolverTypeWrapper<Device>;
  DeviceCommandOutput: ResolverTypeWrapper<DeviceCommandOutput>;
  DeviceLiveData: ResolverTypeWrapper<DeviceLiveData>;
  DeviceStatusReport: ResolverTypeWrapper<DeviceStatusReport>;
  DeviceStatusType: DeviceStatusType;
  Event: ResolverTypeWrapper<Event>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  League: ResolverTypeWrapper<League>;
  Location: ResolverTypeWrapper<Location>;
  LoginInput: LoginInput;
  MediaItem: ResolverTypeWrapper<MediaItem>;
  MediaType: MediaType;
  MetricsDeviceStats: ResolverTypeWrapper<MetricsDeviceStats>;
  MetricsLocationData: ResolverTypeWrapper<MetricsLocationData>;
  MetricsLocationDeviceData: ResolverTypeWrapper<MetricsLocationDeviceData>;
  MetricsLocationStats: ResolverTypeWrapper<MetricsLocationStats>;
  Mutation: ResolverTypeWrapper<{}>;
  NewCustomerInput: NewCustomerInput;
  NewDeviceInput: NewDeviceInput;
  NewLocationInput: NewLocationInput;
  NewMediaItemInput: NewMediaItemInput;
  NewScheduledSlideshowInput: NewScheduledSlideshowInput;
  NewSlideInput: NewSlideInput;
  NewSlideshowInput: NewSlideshowInput;
  NewUpcomingEventsInput: NewUpcomingEventsInput;
  NewUserInput: NewUserInput;
  Query: ResolverTypeWrapper<{}>;
  ScheduledSlideshow: ResolverTypeWrapper<ScheduledSlideshow>;
  Slide: ResolverTypeWrapper<Slide>;
  SlideInput: SlideInput;
  SlideType: SlideType;
  Slideshow: ResolverTypeWrapper<Slideshow>;
  SlideshowInput: SlideshowInput;
  SlideshowLevel: SlideshowLevel;
  SlideshowVersion: ResolverTypeWrapper<SlideshowVersion>;
  SlideshowVersionInput: SlideshowVersionInput;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Team: ResolverTypeWrapper<Team>;
  TimeUnit: TimeUnit;
  TransitionType: TransitionType;
  UpdateDeviceInput: UpdateDeviceInput;
  UpdateDevicePropertiesInput: UpdateDevicePropertiesInput;
  UpdateMediaItemInput: UpdateMediaItemInput;
  UpdateScheduledSlideshowInput: UpdateScheduledSlideshowInput;
  UpdateUserInput: UpdateUserInput;
  User: ResolverTypeWrapper<User>;
  UserRole: UserRole;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Advertisement: Advertisement;
  AuthResponse: AuthResponse;
  Boolean: Scalars['Boolean']['output'];
  Customer: Customer;
  Device: Device;
  DeviceCommandOutput: DeviceCommandOutput;
  DeviceLiveData: DeviceLiveData;
  DeviceStatusReport: DeviceStatusReport;
  Event: Event;
  Float: Scalars['Float']['output'];
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  League: League;
  Location: Location;
  LoginInput: LoginInput;
  MediaItem: MediaItem;
  MetricsDeviceStats: MetricsDeviceStats;
  MetricsLocationData: MetricsLocationData;
  MetricsLocationDeviceData: MetricsLocationDeviceData;
  MetricsLocationStats: MetricsLocationStats;
  Mutation: {};
  NewCustomerInput: NewCustomerInput;
  NewDeviceInput: NewDeviceInput;
  NewLocationInput: NewLocationInput;
  NewMediaItemInput: NewMediaItemInput;
  NewScheduledSlideshowInput: NewScheduledSlideshowInput;
  NewSlideInput: NewSlideInput;
  NewSlideshowInput: NewSlideshowInput;
  NewUpcomingEventsInput: NewUpcomingEventsInput;
  NewUserInput: NewUserInput;
  Query: {};
  ScheduledSlideshow: ScheduledSlideshow;
  Slide: Slide;
  SlideInput: SlideInput;
  Slideshow: Slideshow;
  SlideshowInput: SlideshowInput;
  SlideshowVersion: SlideshowVersion;
  SlideshowVersionInput: SlideshowVersionInput;
  String: Scalars['String']['output'];
  Team: Team;
  UpdateDeviceInput: UpdateDeviceInput;
  UpdateDevicePropertiesInput: UpdateDevicePropertiesInput;
  UpdateMediaItemInput: UpdateMediaItemInput;
  UpdateScheduledSlideshowInput: UpdateScheduledSlideshowInput;
  UpdateUserInput: UpdateUserInput;
  User: User;
};

export type AdvertisementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Advertisement'] = ResolversParentTypes['Advertisement']> = {
  placementId: Resolver<ResolversTypes['AdPlacementId'], ParentType, ContextType>;
  url: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthResponse'] = ResolversParentTypes['AuthResponse']> = {
  token: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Customer'] = ResolversParentTypes['Customer']> = {
  customerId: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  detachedDevices: Resolver<Maybe<Array<Maybe<ResolversTypes['Device']>>>, ParentType, ContextType>;
  locations: Resolver<Maybe<Array<Maybe<ResolversTypes['Location']>>>, ParentType, ContextType>;
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Device'] = ResolversParentTypes['Device']> = {
  commandOutputs: Resolver<Maybe<Array<Maybe<ResolversTypes['DeviceCommandOutput']>>>, ParentType, ContextType>;
  deviceId: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceProperties: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpd: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  screenshotTimestamp: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  screenshotUrl: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slides: Resolver<Maybe<Array<Maybe<ResolversTypes['Slide']>>>, ParentType, ContextType>;
  slideshowVersions: Resolver<Maybe<Array<Maybe<ResolversTypes['SlideshowVersion']>>>, ParentType, ContextType>;
  status: Resolver<Maybe<ResolversTypes['DeviceStatusType']>, ParentType, ContextType>;
  statusReport: Resolver<Maybe<ResolversTypes['DeviceStatusReport']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceCommandOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceCommandOutput'] = ResolversParentTypes['DeviceCommandOutput']> = {
  command: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceId: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  output: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receivedAt: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceLiveDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceLiveData'] = ResolversParentTypes['DeviceLiveData']> = {
  activeDevices: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  aspectRatio: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commandOutputs: Resolver<Maybe<Array<Maybe<ResolversTypes['DeviceCommandOutput']>>>, ParentType, ContextType>;
  deviceId: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceName: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastTimeActiveDevices: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastTimeConnected: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationName: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusReport: Resolver<Maybe<ResolversTypes['DeviceStatusReport']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceStatusReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceStatusReport'] = ResolversParentTypes['DeviceStatusReport']> = {
  avgLoad: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  connectedSsid: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cpuLoad: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  diskTotalGB: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  diskUsedGB: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  hdmi1_rotation: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hdmi2_rotation: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metrics: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  temperature: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  time: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalMemMB: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uptimeMin: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  usedMemMB: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventResolvers<ContextType = any, ParentType extends ResolversParentTypes['Event'] = ResolversParentTypes['Event']> = {
  away: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>;
  awayScore: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  clock: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closed: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasOdds: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  home: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>;
  homeScore: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  leagueId: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  live: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sportId: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startTime: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeagueResolvers<ContextType = any, ParentType extends ResolversParentTypes['League'] = ResolversParentTypes['League']> = {
  country: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sportId: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = {
  customerId: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  devices: Resolver<Maybe<Array<Maybe<ResolversTypes['Device']>>>, ParentType, ContextType>;
  locationId: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metrics: Resolver<Maybe<ResolversTypes['MetricsLocationData']>, ParentType, ContextType, LocationMetricsArgs>;
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slideshows: Resolver<Maybe<Array<Maybe<ResolversTypes['Slideshow']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MediaItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['MediaItem'] = ResolversParentTypes['MediaItem']> = {
  createdByUser: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  customerId: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  height: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastUpd: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaItemId: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  previewURL: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  type: Resolver<ResolversTypes['MediaType'], ParentType, ContextType>;
  url: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  width: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetricsDeviceStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetricsDeviceStats'] = ResolversParentTypes['MetricsDeviceStats']> = {
  activeDevices: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deviceId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromRoundedTimestamp: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toRoundedTimestamp: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetricsLocationDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetricsLocationData'] = ResolversParentTypes['MetricsLocationData']> = {
  liveData: Resolver<Maybe<ResolversTypes['MetricsLocationStats']>, ParentType, ContextType>;
  locationData: Resolver<Maybe<Array<Maybe<ResolversTypes['MetricsLocationStats']>>>, ParentType, ContextType>;
  locationId: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetricsLocationDeviceDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetricsLocationDeviceData'] = ResolversParentTypes['MetricsLocationDeviceData']> = {
  deviceData: Resolver<Maybe<Array<Maybe<ResolversTypes['MetricsDeviceStats']>>>, ParentType, ContextType>;
  locationId: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetricsLocationStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetricsLocationStats'] = ResolversParentTypes['MetricsLocationStats']> = {
  activeDevices: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fromRoundedTimestamp: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toRoundedTimestamp: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  createCustomer: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType, RequireFields<MutationCreateCustomerArgs, 'input'>>;
  createDevice: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType, RequireFields<MutationCreateDeviceArgs, 'input'>>;
  createLocation: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType, RequireFields<MutationCreateLocationArgs, 'input'>>;
  createMediaItem: Resolver<Maybe<ResolversTypes['MediaItem']>, ParentType, ContextType, RequireFields<MutationCreateMediaItemArgs, 'input'>>;
  createSlide: Resolver<Maybe<ResolversTypes['Slide']>, ParentType, ContextType, RequireFields<MutationCreateSlideArgs, 'input'>>;
  createSlideshow: Resolver<Maybe<ResolversTypes['Slideshow']>, ParentType, ContextType, RequireFields<MutationCreateSlideshowArgs, 'input'>>;
  createUser: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationCreateUserArgs, 'input'>>;
  deleteDevice: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationDeleteDeviceArgs, 'deviceId'>>;
  deleteMediaItem: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationDeleteMediaItemArgs, 'mediaItemId'>>;
  deleteScheduledSlideshow: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationDeleteScheduledSlideshowArgs, 'slideshowId'>>;
  deleteScheduledSlideshowById: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationDeleteScheduledSlideshowByIdArgs, 'id'>>;
  deleteSlide: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationDeleteSlideArgs, 'slideId'>>;
  deleteSlideshow: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationDeleteSlideshowArgs, 'slideshowId'>>;
  deleteUser: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationDeleteUserArgs, 'username'>>;
  detachDevice: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationDetachDeviceArgs, 'deviceId'>>;
  loginUser: Resolver<Maybe<ResolversTypes['AuthResponse']>, ParentType, ContextType, RequireFields<MutationLoginUserArgs, 'input'>>;
  scheduleSlideshow: Resolver<Maybe<ResolversTypes['ScheduledSlideshow']>, ParentType, ContextType, RequireFields<MutationScheduleSlideshowArgs, 'input'>>;
  setDeviceCommands: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationSetDeviceCommandsArgs, 'commands' | 'deviceId'>>;
  setUpcomingEvents: Resolver<Maybe<Array<Maybe<ResolversTypes['Event']>>>, ParentType, ContextType, RequireFields<MutationSetUpcomingEventsArgs, 'input'>>;
  updateDevice: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType, RequireFields<MutationUpdateDeviceArgs, 'input'>>;
  updateDeviceProperties: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType, RequireFields<MutationUpdateDevicePropertiesArgs, 'input'>>;
  updateMediaItem: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationUpdateMediaItemArgs, 'input'>>;
  updateScheduledSlideshow: Resolver<Maybe<ResolversTypes['ScheduledSlideshow']>, ParentType, ContextType, RequireFields<MutationUpdateScheduledSlideshowArgs, 'input'>>;
  updateSlide: Resolver<Maybe<ResolversTypes['Slide']>, ParentType, ContextType, RequireFields<MutationUpdateSlideArgs, 'input'>>;
  updateSlideshow: Resolver<Maybe<ResolversTypes['Slideshow']>, ParentType, ContextType, RequireFields<MutationUpdateSlideshowArgs, 'input'>>;
  updateUser: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUpdateUserArgs, 'input'>>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  getCustomers: Resolver<Maybe<Array<Maybe<ResolversTypes['Customer']>>>, ParentType, ContextType>;
  getDevice: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType, RequireFields<QueryGetDeviceArgs, 'deviceId'>>;
  getDeviceSlides: Resolver<Maybe<Array<Maybe<ResolversTypes['Slide']>>>, ParentType, ContextType, RequireFields<QueryGetDeviceSlidesArgs, 'deviceId'>>;
  getDevicesLive: Resolver<Maybe<Array<Maybe<ResolversTypes['DeviceLiveData']>>>, ParentType, ContextType>;
  getEvents: Resolver<Maybe<Array<Maybe<ResolversTypes['Event']>>>, ParentType, ContextType, QueryGetEventsArgs>;
  getEventsByIds: Resolver<Maybe<Array<Maybe<ResolversTypes['Event']>>>, ParentType, ContextType, RequireFields<QueryGetEventsByIdsArgs, 'list'>>;
  getLeagues: Resolver<Maybe<Array<Maybe<ResolversTypes['League']>>>, ParentType, ContextType>;
  getLocation: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType, RequireFields<QueryGetLocationArgs, 'locationId'>>;
  getLocationDeviceMetrics: Resolver<Maybe<ResolversTypes['MetricsLocationDeviceData']>, ParentType, ContextType, RequireFields<QueryGetLocationDeviceMetricsArgs, 'locationId'>>;
  getLocationMetrics: Resolver<Maybe<ResolversTypes['MetricsLocationData']>, ParentType, ContextType, RequireFields<QueryGetLocationMetricsArgs, 'endTime' | 'locationId' | 'startTime'>>;
  getMediaItem: Resolver<Maybe<ResolversTypes['MediaItem']>, ParentType, ContextType, RequireFields<QueryGetMediaItemArgs, 'mediaItemId'>>;
  getMediaItems: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaItem']>>>, ParentType, ContextType, RequireFields<QueryGetMediaItemsArgs, 'customerId'>>;
  getScheduledSlideshows: Resolver<Maybe<Array<Maybe<ResolversTypes['ScheduledSlideshow']>>>, ParentType, ContextType, RequireFields<QueryGetScheduledSlideshowsArgs, 'slideshowId'>>;
  getSlide: Resolver<Maybe<ResolversTypes['Slide']>, ParentType, ContextType, RequireFields<QueryGetSlideArgs, 'slideId'>>;
  getSlides: Resolver<Maybe<Array<Maybe<ResolversTypes['Slide']>>>, ParentType, ContextType, RequireFields<QueryGetSlidesArgs, 'customerId'>>;
  getSlideshow: Resolver<Maybe<ResolversTypes['Slideshow']>, ParentType, ContextType, RequireFields<QueryGetSlideshowArgs, 'slideshowId'>>;
  getSlideshows: Resolver<Maybe<Array<Maybe<ResolversTypes['Slideshow']>>>, ParentType, ContextType, RequireFields<QueryGetSlideshowsArgs, 'customerId' | 'level'>>;
  getUsers: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType, QueryGetUsersArgs>;
};

export type ScheduledSlideshowResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledSlideshow'] = ResolversParentTypes['ScheduledSlideshow']> = {
  dateTime: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceIds: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  id: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastUpd: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationIds: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processed: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  slideshowId: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slideshowType: Resolver<ResolversTypes['SlideshowLevel'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SlideResolvers<ContextType = any, ParentType extends ResolversParentTypes['Slide'] = ResolversParentTypes['Slide']> = {
  ads: Resolver<Maybe<Array<Maybe<ResolversTypes['Advertisement']>>>, ParentType, ContextType>;
  createdByUser: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  customerId: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  data: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  elements: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaItem']>>>, ParentType, ContextType>;
  lastUpd: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  layout: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  previewURL: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slideId: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tags: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  type: Resolver<Maybe<ResolversTypes['SlideType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SlideshowResolvers<ContextType = any, ParentType extends ResolversParentTypes['Slideshow'] = ResolversParentTypes['Slideshow']> = {
  aspectRatio: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerId: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastUpd: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  level: Resolver<Maybe<ResolversTypes['SlideshowLevel']>, ParentType, ContextType>;
  locationIds: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schedules: Resolver<Maybe<Array<Maybe<ResolversTypes['ScheduledSlideshow']>>>, ParentType, ContextType>;
  slideIds: Resolver<Maybe<Array<Maybe<ResolversTypes['ID']>>>, ParentType, ContextType>;
  slides: Resolver<Maybe<Array<Maybe<ResolversTypes['Slide']>>>, ParentType, ContextType>;
  slideshowId: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userName: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SlideshowVersionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SlideshowVersion'] = ResolversParentTypes['SlideshowVersion']> = {
  level: Resolver<Maybe<ResolversTypes['SlideshowLevel']>, ParentType, ContextType>;
  slideshowId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['Team'] = ResolversParentTypes['Team']> = {
  country: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gender: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logo: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortName: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sportId: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  customer: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType>;
  customerId: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  locations: Resolver<Maybe<Array<Maybe<ResolversTypes['Location']>>>, ParentType, ContextType>;
  role: Resolver<Maybe<ResolversTypes['UserRole']>, ParentType, ContextType>;
  userName: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Advertisement: AdvertisementResolvers<ContextType>;
  AuthResponse: AuthResponseResolvers<ContextType>;
  Customer: CustomerResolvers<ContextType>;
  Device: DeviceResolvers<ContextType>;
  DeviceCommandOutput: DeviceCommandOutputResolvers<ContextType>;
  DeviceLiveData: DeviceLiveDataResolvers<ContextType>;
  DeviceStatusReport: DeviceStatusReportResolvers<ContextType>;
  Event: EventResolvers<ContextType>;
  League: LeagueResolvers<ContextType>;
  Location: LocationResolvers<ContextType>;
  MediaItem: MediaItemResolvers<ContextType>;
  MetricsDeviceStats: MetricsDeviceStatsResolvers<ContextType>;
  MetricsLocationData: MetricsLocationDataResolvers<ContextType>;
  MetricsLocationDeviceData: MetricsLocationDeviceDataResolvers<ContextType>;
  MetricsLocationStats: MetricsLocationStatsResolvers<ContextType>;
  Mutation: MutationResolvers<ContextType>;
  Query: QueryResolvers<ContextType>;
  ScheduledSlideshow: ScheduledSlideshowResolvers<ContextType>;
  Slide: SlideResolvers<ContextType>;
  Slideshow: SlideshowResolvers<ContextType>;
  SlideshowVersion: SlideshowVersionResolvers<ContextType>;
  Team: TeamResolvers<ContextType>;
  User: UserResolvers<ContextType>;
};

